import axios from "axios";

export default {
  namespaced: true,
  state: {
    reimbursements: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    reimbursementsMessage: ''
  },
  mutations: {
    CLEAR_REIMBURSEMENTS(state) {
      state.reimbursements = [];
    },
    RECEIVED_REIMBURSEMENTS(state, payload) {
      state.reimbursements = payload;
      state.isReceiving = false;
    },
    RECEIVING_REIMBURSEMENTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_REIMBURSEMENT(state, payload) {
      state = Object.assign(state, {
        reimbursements: [...state.reimbursements, payload],
        isReceiving: false,
      })
    },
    RECEIVING_REIMBURSEMENT(state) {
      state.isReceiving = true;
    },
    UPDATED_REIMBURSEMENT(state, payload) {
      console.log(state.reimbursements);
      console.log(payload);
      let index = state.reimbursements.findIndex(reimbursement => reimbursement._id === payload._id);
      state = Object.assign(state, {
        reimbursements: state.reimbursements.map((reimbursement, i) => {
          if (i === index) {
            return Object.assign({}, reimbursement, payload);
          }
          return reimbursement;
        }),
        isUpdating: false,
        reimbursementsMessage: 'Reimbursements has been updating!',
      })
    },
    UPDATING_REIMBURSEMENT(state) {
      state.isUpdating = true;
    },
    DELETED_REIMBURSEMENT(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.reimbursements.findIndex(reimbursement => reimbursement._id === payload._id);
      console.log(indexToDelete);
      let reimbursements = [...state.reimbursements];
      reimbursements.splice(indexToDelete, 1);
      state = Object.assign(state, {
        reimbursements: [...reimbursements],
        isDeleting: false,
        idToDelete: null,
        reimbursementsMessage: 'Reimbursement has been Deleted!',
      });
    },
    DELETE_ROLE_SUCCESS(state, payload) {
      let indexToDelete = state.roles.findIndex(role => role._id === payload._id);
      console.log(indexToDelete);
      let roles = [...state.roles];
      roles.splice(indexToDelete, 1);
      state = Object.assign(state, {
        roles: [...roles],
        isDeleting: false,
        idToDelete: null,
        rolesMessage: 'Role has been Deleted!',
      });
    },
    DELETING_REIMBURSEMENT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async insertReimbursementRequest({dispatch}, payload) {
      dispatch("receivingReimbursements");
      let data = payload;
      var token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/reimbursement'; 
      let header = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      await axios({method: "post", url: url, headers: header, data: data})
      .then(response=> {
        console.log('reimbursement', response.data);
        dispatch("receiveReimbursement", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    async deleteReimbursementRequest({dispatch}, payload) {
      dispatch("deletingReimbursement", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.accountxc.com:3100/delete/reimbursement/' + payload._id;
      let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        dispatch("deleteReimbursement", {_id: response.data._id});
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async emailReimbursementRequest({dispatch}, payload) {
      dispatch("updatingReimbursement", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/email/reimbursement/' + payload._id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "POST", url: url, headers: headers});
      return response.data;
    },
    async getReimbursementsRequest({dispatch}) {
      dispatch("receivingReimbursements");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/reimbursements';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};  
      return axios({method: "get", url: url, headers: header})
      .then(res => {
        dispatch("receiveReimbursements", res.data);
      })
    },
    async getReimbursementQueryRequest({dispatch}, payload) {
      console.log(payload)
      try{
        dispatch("receivingReimbursements");
        let token = localStorage.getItem('token');
        console.log(token)
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/get/reimbursements/byquery';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveReimbursements", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateReimbursementRequest({dispatch}, payload) {
      dispatch("updatingReimbursement");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/reimbursement/changestatus/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
  
      axios({method: "PUT", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateReimbursement", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async updateReimbursementPendingRequest({dispatch}, payload) {
      dispatch("updatingReimbursement");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/update/reimbursement/pending/' + id;
      var header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method:"put", url:url, headers:header, data:payload})
      dispatch("updateReimbursement", response.data);
      return response.data;
    },
    updateReimbursementImageRequest({dispatch}, payload) {
      dispatch("updatingReimbursement");
      var data;
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];
      console.log(id, payload);

      var url = 'https://api.accountxc.com:3100/update/reimbursement/image/' + id;
      data = new FormData();
      data.append('image', payload.reimbursementimage, payload.imagename); 
      delete payload['reimbursementimage'];
      for (let x in payload) {
        data.append(x, payload[x]);
      }
      header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };

      axios(post)
      .then(function (res) {
        console.log(res);
        dispatch("updateReimbursement", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    clearReimbursements({commit}) {
      commit("CLEAR_REIMBURSEMENTS")
    },
    receiveReimbursements({commit}, payload) {
      commit("RECEIVED_REIMBURSEMENTS", payload)
    },
    receivingReimbursements({commit}) {
      commit("RECEIVING_REIMBURSEMENTS")
    },
    receiveReimbursement({commit}, payload) {
      commit("RECEIVED_REIMBURSEMENT", payload)
    },
    receivingReimbursement({commit}) {
      commit("RECEIVING_REIMBURSEMENT")
    },
    updateReimbursement({commit}, payload) {
      commit("UPDATED_REIMBURSEMENT", payload)
    },
    updatingReimbursement({commit}) {
      commit("UPDATING_REIMBURSEMENT")
    },
    deleteReimbursement({commit}, payload) {
      commit("DELETED_REIMBURSEMENT", payload)
    },
    deletingReimbursement({commit}, payload) {
      commit("DELETING_REIMBURSEMENT", payload)
    }
  },
};
